import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { CONTACT } from '../mock/data';

const LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Dining', to: '/dining' },
  { label: 'Events', to: '/events' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Contact', to: '/contact' }
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || !isHome;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid ? 'bg-ink/95 backdrop-blur-md shadow-lg shadow-black/20 py-2.5' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link
          to="/"
          className={`flex flex-col leading-none transition-all duration-500 ${
            solid ? 'w-44 md:w-48' : 'w-48 md:w-56'
          }`}
        >
          <img src="/vivamore-mark.webp" alt="Vivamore Dining" className="w-full h-auto block" />
          <div className="flex justify-between w-full mt-1.5 text-[8px] md:text-[9px] uppercase text-cream font-medium">
            <span>Convenient</span>
            <span>&middot;</span>
            <span>Connect</span>
            <span>&middot;</span>
            <span>Celebrate</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`nav-link text-sm tracking-wider uppercase transition-colors duration-300 ${
                location.pathname === l.to ? 'active text-gold-light' : 'text-cream/85 hover:text-gold-light'
              }`}
            >
              {l.label}
            </Link>
          ))}
          <a
            href={CONTACT.whatsappReserve}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold text-xs tracking-widest uppercase px-6 py-3 border border-gold text-gold-light hover:bg-gold hover:text-cream"
          >
            Reserve
          </a>
        </nav>

        <button
          className="lg:hidden text-cream"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Menu size={26} />
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`fixed inset-0 z-50 transition-all duration-500 lg:hidden ${
          open ? 'visible opacity-100' : 'invisible opacity-0'
        }`}
      >
        <div className="absolute inset-0 bg-ink/95 backdrop-blur-sm" onClick={() => setOpen(false)} />
        <div
          className={`absolute right-0 top-0 h-full w-4/5 max-w-sm bg-ink text-cream p-8 flex flex-col transition-transform duration-500 ${
            open ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex justify-between items-center mb-12">
            <img src="/vivamore-mark.webp" alt="Vivamore" className="h-10 w-auto" />
            <button onClick={() => setOpen(false)} aria-label="Close menu">
              <X size={26} />
            </button>
          </div>
          <nav className="flex flex-col gap-6">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className={`font-serif text-3xl transition-colors ${
                  location.pathname === l.to ? 'text-gold' : 'text-cream hover:text-gold'
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <a
            href={CONTACT.whatsappReserve}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-gold mt-auto text-xs tracking-widest uppercase px-6 py-4 border border-gold text-gold hover:bg-gold hover:text-ink text-center"
          >
            Reserve A Table
          </a>
        </div>
      </div>
    </header>
  );
}
